export default {
    create_partnumber_create_title: "Nueva número de pieza",
    create_partnumber_edit_title: "Editar número de pieza",
    create_partnumber_create_success_message: "Se ha creado el número de pieza",
    create_partnumber_update_success_message: "El número de pieza ha sido editado",
    create_partnumber_manufacturer: "Fabricante",
    create_partnumber_part_number: "Número de pieza",
    create_partnumber_device_model: "Modelo de dispositivo",
    create_partnumber_network: "Red",
}